(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var gridSection = document.querySelector('.collection-grid-section');
    if (gridSection) {
      try {
        console.log(
          '[tag-filters debug]',
          'collection.handle=', gridSection.getAttribute('data-debug-collection-handle'),
          '| handle_ok=', gridSection.getAttribute('data-debug-handle-ok')
        );
      } catch (e) {}
    }

    var filtersRoot = document.getElementById('collection-tag-filters');
    var grid        = document.getElementById('collection-grid');
    if (!filtersRoot || !grid) return;

    var badges  = filtersRoot.querySelectorAll('.collection-tag-filter');
    var emptyEl = document.getElementById('collection-tag-filters-empty');
    if (!badges.length) return;

    function normalize(value) {
      if (value === null || value === undefined) return '';
      var s = String(value);
      s = s.replace(/\u00A0/g, ' ');
      s = s.replace(/[\u2018\u2019\u02BC\u2032]/g, "'");
      s = s.replace(/[\u201C\u201D\u2033]/g, '"');
      if (typeof s.normalize === 'function') {
        try { s = s.normalize('NFC'); } catch (e) {}
      }
      return s.trim().toLowerCase();
    }

    var cards = grid.querySelectorAll('.collection-card');
    var cardTagsCache = [];
    cards.forEach(function (card) {
      var raw  = card.getAttribute('data-product-tags') || '';
      var list = raw.split(',').map(normalize).filter(Boolean);
      cardTagsCache.push(list);
    });

    var activeTag = null;

    function applyFilter() {
      var visibleCount = 0;

      cards.forEach(function (card, idx) {
        var match;
        if (!activeTag) {
          match = true;
        } else {
          match = cardTagsCache[idx].indexOf(activeTag) !== -1;
        }

        if (match) {
          card.removeAttribute('hidden');
          visibleCount += 1;
        } else {
          card.setAttribute('hidden', '');
        }
      });

      badges.forEach(function (b) {
        var btag     = normalize(b.getAttribute('data-filter-tag'));
        var isActive = activeTag && btag === activeTag;
        b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        b.classList.toggle('collection-tag-filter--active', !!isActive);
      });

      if (emptyEl) {
        if (activeTag && visibleCount === 0) {
          emptyEl.removeAttribute('hidden');
        } else {
          emptyEl.setAttribute('hidden', '');
        }
      }
    }

    badges.forEach(function (b) {
      b.addEventListener('click', function () {
        var tag = normalize(b.getAttribute('data-filter-tag'));
        if (!tag) return;
        activeTag = (activeTag === tag) ? null : tag;
        applyFilter();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var toggle = document.getElementById('header-menu-toggle');
    var nav    = document.getElementById('header-mobile-nav');
    var header = document.querySelector('.site-header');

    if (header) {
      var context = header.getAttribute('data-region-context') || 'default';
      var varHomeUrl = header.getAttribute('data-var-home-url') || '/pages/plombier-var-toulon-hyeres-bandol-le-lavandou';
      var defaultHomeUrl = header.getAttribute('data-default-home-url') || '/';
      var varFuiteUrl = header.getAttribute('data-var-fuite-url') || '/pages/recherche-de-fuite-var';
      var defaultFuiteUrl = header.getAttribute('data-default-fuite-url') || '/pages/recherche-de-fuite';
      var currentPath = window.location.pathname.replace(/\/$/, '') || '/';
      var defaultLocalPages = ['/pages/recherche-de-fuite', '/pages/recherche-de-fuite-niort', '/pages/recherche-de-fuite-chatellerault'];
      var region = context === 'var' ? 'var' : '';

      try {
        if (context === 'var') {
          window.localStorage.setItem('adplus_region', 'var');
        } else if (currentPath === '/' || currentPath === '' || defaultLocalPages.indexOf(currentPath) !== -1) {
          window.localStorage.removeItem('adplus_region');
        }
        region = window.localStorage.getItem('adplus_region') || region;
      } catch (e) {
        region = context === 'var' ? 'var' : '';
      }

      function updateVarFooterZones() {
        document.querySelectorAll('[data-region-footer-zones]').forEach(function (item) {
          var text = item.getAttribute('data-var-text');
          if (text) item.textContent = text;
        });
      }

      function applyVarRegionToDom() {
        document.querySelectorAll('[data-region-home-link]').forEach(function (link) {
          link.setAttribute('href', varHomeUrl);
        });
        document.querySelectorAll('[data-region-fuite-link]').forEach(function (link) {
          link.setAttribute('href', varFuiteUrl);
        });
        document.querySelectorAll('[data-region-tagline]').forEach(function (item) {
          var text = item.getAttribute('data-var-text');
          if (text) item.textContent = text;
        });
        updateVarFooterZones();
      }

      if (region === 'var') {
        applyVarRegionToDom();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', applyVarRegionToDom);
        }
      } else {
        document.querySelectorAll('[data-region-home-link]').forEach(function (link) {
          link.setAttribute('href', defaultHomeUrl);
        });
        document.querySelectorAll('[data-region-fuite-link]').forEach(function (link) {
          link.setAttribute('href', defaultFuiteUrl);
        });
      }
    }

    if (!toggle || !nav || !header) return;

    toggle.addEventListener('click', function () {
      var isOpen = header.classList.toggle('site-header--open');
      toggle.setAttribute('aria-expanded', String(isOpen));
      nav.setAttribute('aria-hidden', String(!isOpen));
      toggle.setAttribute('aria-label', isOpen ? 'Fermer le menu' : 'Ouvrir le menu');
    });

    nav.querySelectorAll('.header__mobile-link, .header__mobile-leak, .header__mobile-depannage, .header__mobile-visit, .header__mobile-phone').forEach(function (link) {
      link.addEventListener('click', function () {
        header.classList.remove('site-header--open');
        toggle.setAttribute('aria-expanded', 'false');
        nav.setAttribute('aria-hidden', 'true');
        toggle.setAttribute('aria-label', 'Ouvrir le menu');
      });
    });

    var searchToggle = document.getElementById('header-search-toggle');
    var searchForm   = document.getElementById('header-search');
    var searchInput  = document.getElementById('header-search-input');

    if (searchToggle && searchForm) {
      searchToggle.addEventListener('click', function () {
        var isOpen = header.classList.toggle('site-header--search-open');
        searchToggle.setAttribute('aria-expanded', String(isOpen));
        searchToggle.setAttribute('aria-label', isOpen ? 'Fermer la recherche' : 'Ouvrir la recherche');
        if (isOpen && searchInput) {
          window.setTimeout(function () { searchInput.focus(); }, 50);
        }
      });

      if (searchInput) {
        searchInput.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && header.classList.contains('site-header--search-open')) {
            header.classList.remove('site-header--search-open');
            searchToggle.setAttribute('aria-expanded', 'false');
            searchToggle.setAttribute('aria-label', 'Ouvrir la recherche');
            searchToggle.focus();
          }
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-intervention-zone"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.home-intervention-zone__video-placeholder');
    if (!root) return;
    var video = root.querySelector('video');
    if (!video) return;
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    var play = function () {
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    };
    if (video.readyState >= 2) play();
    else video.addEventListener('loadeddata', play, { once: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-home-testimonials]').forEach(function (root) {
      var track = root.querySelector('[data-testimonial-track]');
      var slides = root.querySelectorAll('[data-testimonial-slide]');
      var prev = root.querySelector('[data-testimonial-prev]');
      var next = root.querySelector('[data-testimonial-next]');
      var dots = root.querySelectorAll('[data-testimonial-dot]');
      if (!track || slides.length === 0) return;

      var i = 0;
      var n = slides.length;

      function setDotActive(idx) {
        dots.forEach(function (d) {
          d.classList.toggle('is-active', Number(d.getAttribute('data-index')) === idx);
        });
      }

      function go(idx) {
        i = (idx + n) % n;
        track.style.transform = 'translateX(-' + i * 100 + '%)';
        setDotActive(i);
      }

      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      if (next) next.addEventListener('click', function () { go(i + 1); });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          go(Number(dot.getAttribute('data-index')));
        });
      });

      /* Mobile : swipe horizontal (aucune logique tactile avant — seuls les dots fonctionnaient) */
      var viewport = root.querySelector('.home-testimonials__viewport');
      var touchStartX = 0;
      var touchStartY = 0;
      var touchActive = false;

      function bindSwipe() {
        if (!viewport || n <= 1) return;

        viewport.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) return;
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
          touchActive = true;
        }, { passive: true });

        viewport.addEventListener('touchmove', function (e) {
          if (!touchActive || e.touches.length !== 1) return;
          var dx = e.touches[0].clientX - touchStartX;
          var dy = e.touches[0].clientY - touchStartY;
          if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 12) {
            e.preventDefault();
          }
        }, { passive: false });

        viewport.addEventListener('touchend', function (e) {
          if (!touchActive) return;
          touchActive = false;
          if (!e.changedTouches.length) return;
          var dx = e.changedTouches[0].clientX - touchStartX;
          var dy = e.changedTouches[0].clientY - touchStartY;
          if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy)) return;
          if (dx < 0) go(i + 1);
          else go(i - 1);
        }, { passive: true });
      }

      bindSwipe();

      if (n <= 1) {
        if (prev) prev.style.visibility = 'hidden';
        if (next) next.style.visibility = 'hidden';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (/\benvoi=ok\b/.test(window.location.search)) {
      var ok = document.getElementById('contact-envoi-ok');
      var form = document.querySelector('.contact-form');
      if (ok) ok.hidden = false;
      if (form) form.hidden = true;
    }

    var root = document.querySelector('[data-contact-photos]');
    if (!root) return;

    var fileInput = root.querySelector('.contact-photos__input');
    var dropzone  = root.querySelector('[data-photos-dropzone]');
    var listEl    = root.querySelector('[data-photos-list]');
    var warningEl = root.querySelector('[data-photos-warning]');
    var contactForm = root.closest('form');
    var maxPhotos = Math.min(parseInt(root.getAttribute('data-max-photos') || '5', 10) || 5, 5);

    if (!fileInput || !dropzone || !listEl) return;

    var ACCEPTED_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
    var MAX_FILE_BYTES = 9000000;
    var photos = [];

    function setWarning(msg) {
      if (!warningEl) return;
      if (!msg) {
        warningEl.textContent = '';
        warningEl.setAttribute('hidden', '');
      } else {
        warningEl.textContent = msg;
        warningEl.removeAttribute('hidden');
      }
    }

    function syncFileInput() {
      var dt = new DataTransfer();
      photos.forEach(function (photo) {
        if (!photo.tooLarge && photo.file) {
          dt.items.add(photo.file);
        }
      });
      fileInput.files = dt.files;
    }

    function renderList() {
      listEl.innerHTML = '';
      if (!photos.length) {
        listEl.setAttribute('hidden', '');
        return;
      }
      listEl.removeAttribute('hidden');

      photos.forEach(function (photo, index) {
        var li = document.createElement('li');
        li.className = 'contact-photos__item' + (photo.tooLarge ? ' contact-photos__item--error' : '');

        var img = document.createElement('img');
        img.className = 'contact-photos__thumb';
        img.alt = '';
        img.src = photo.preview;
        img.width = 38;
        img.height = 38;
        li.appendChild(img);

        var name = document.createElement('span');
        name.className = 'contact-photos__item-name';
        name.textContent = photo.name;
        li.appendChild(name);

        var meta = document.createElement('span');
        meta.className = 'contact-photos__item-meta';
        meta.textContent = photo.tooLarge ? 'Trop volumineuse' : 'Jointe';
        li.appendChild(meta);

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'contact-photos__remove';
        remove.setAttribute('aria-label', 'Retirer la photo ' + photo.name);
        remove.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
        remove.addEventListener('click', function () {
          photos.splice(index, 1);
          syncFileInput();
          renderList();
        });
        li.appendChild(remove);

        listEl.appendChild(li);
      });
    }

    function updateWarnings() {
      var rejetees = photos.filter(function (p) { return p.tooLarge; }).length;
      var msgs = [];
      if (rejetees > 0) {
        msgs.push('Certaines photos sont trop volumineuses et ne seront pas jointes. Réduisez leur taille ou retirez-les avant l’envoi.');
      }
      setWarning(msgs.join(' '));
    }

    function processFile(file) {
      return new Promise(function (resolve) {
        var typeOk = ACCEPTED_TYPES.indexOf((file.type || '').toLowerCase()) !== -1;
        if (!typeOk) {
          resolve(null);
          return;
        }

        var reader = new FileReader();
        reader.onload = function (e) {
          var img = new Image();
          img.onload = function () {
            var canvas = document.createElement('canvas');
            var maxW = 1200;
            var w = img.width;
            var h = img.height;
            if (w > maxW) { h = Math.round(h * maxW / w); w = maxW; }
            canvas.width = w;
            canvas.height = h;
            canvas.getContext('2d').drawImage(img, 0, 0, w, h);

            canvas.toBlob(function (blob) {
              if (!blob) {
                resolve(null);
                return;
              }

              var baseName = (file.name || 'photo').replace(/\.[^.]+$/, '') || 'photo';
              var outFile = new File([blob], baseName + '.jpg', { type: 'image/jpeg', lastModified: Date.now() });
              var preview = canvas.toDataURL('image/jpeg', 0.82);
              var tooLarge = outFile.size > MAX_FILE_BYTES;

              resolve({
                name: outFile.name,
                file: outFile,
                preview: preview,
                tooLarge: tooLarge
              });
            }, 'image/jpeg', 0.82);
          };
          img.onerror = function () { resolve(null); };
          img.src = e.target.result;
        };
        reader.onerror = function () { resolve(null); };
        reader.readAsDataURL(file);
      });
    }

    function addFiles(fileList) {
      var files = Array.prototype.slice.call(fileList || []);
      if (!files.length) return;

      var remainingSlots = maxPhotos - photos.length;
      var overflow = 0;
      if (files.length > remainingSlots) {
        overflow = files.length - remainingSlots;
        files = files.slice(0, remainingSlots);
      }

      var invalidTypes = 0;
      var promises = files.map(function (f) {
        return processFile(f).then(function (res) {
          if (!res) invalidTypes += 1;
          return res;
        });
      });

      Promise.all(promises).then(function (results) {
        results.forEach(function (r) { if (r) photos.push(r); });
        syncFileInput();
        renderList();
        updateWarnings();

        var notices = [];
        if (warningEl && warningEl.textContent) notices.push(warningEl.textContent);
        if (overflow > 0) notices.push('Maximum ' + maxPhotos + ' photos. Les photos supplémentaires n’ont pas été ajoutées.');
        if (invalidTypes > 0) notices.push(invalidTypes + ' fichier(s) ignoré(s) - format non supporté (JPG, PNG, WEBP uniquement).');
        if (notices.length) setWarning(notices.join(' '));
      });
    }

    fileInput.addEventListener('change', function () {
      addFiles(this.files);
      this.value = '';
    });

    ['dragenter', 'dragover'].forEach(function (evt) {
      dropzone.addEventListener(evt, function (e) {
        e.preventDefault();
        e.stopPropagation();
        dropzone.classList.add('is-dragover');
      });
    });

    ['dragleave', 'drop'].forEach(function (evt) {
      dropzone.addEventListener(evt, function (e) {
        e.preventDefault();
        e.stopPropagation();
        dropzone.classList.remove('is-dragover');
      });
    });

    dropzone.addEventListener('drop', function (e) {
      if (e.dataTransfer && e.dataTransfer.files) {
        addFiles(e.dataTransfer.files);
      }
    });

    if (contactForm) {
      contactForm.addEventListener('submit', function () {
        syncFileInput();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-devis"] && !Shopify.designMode) return;
  try {
    
  (function () {

    /* ════════════════════════════════════════
       HELPERS
    ════════════════════════════════════════ */
    function padTwo(n) {
      return String(n).padStart(2, '0');
    }

    function formatDate(d) {
      return padTwo(d.getDate()) + '/' + padTwo(d.getMonth() + 1) + '/' + d.getFullYear();
    }

    function getDateEcheance() {
      var d = new Date();
      d.setMonth(d.getMonth() + 3);
      return formatDate(d);
    }

    function setEl(id, val) {
      var el = document.getElementById(id);
      if (el) el.textContent = val || '—';
    }

    /* ════════════════════════════════════════
       NORMALISATION DU NOM (3 lettres)
       Retire accents, caractères non alphabétiques,
       met en majuscules, prend les 3 premiers caractères.
       Exemple : "Bélair" → "BEL"
    ════════════════════════════════════════ */
    function nomTag(nom) {
      if (!nom) return 'XXX';
      var clean = nom
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-zA-Z]/g, '')
        .toUpperCase();
      return clean.slice(0, 3) || 'XXX';
    }

    /* ════════════════════════════════════════
       NUMÉRO DE DEVIS
       Format : DV-AAAAMMJJ-[3 lettres nom]-[4 chiffres fixes]
       Exemple : DV-20260406-DUP-4821

       La séquence à 4 chiffres est figée au chargement de la page.
       Seul le tag du nom se met à jour quand le nom change.
    ════════════════════════════════════════ */
    var seqFixe = String(Math.floor(Math.random() * 9000) + 1000);

    function genNumeroDevis(nom) {
      var now = new Date();
      var dateStr = now.getFullYear() +
        padTwo(now.getMonth() + 1) +
        padTwo(now.getDate());
      return 'DV-' + dateStr + '-' + nomTag(nom) + '-' + seqFixe;
    }

    /* ════════════════════════════════════════
       CODE CLIENT
       Format : 4 chiffres + NOM complet majuscules sans espace
       Exemple : 4821DUPONT
       Recalculé uniquement quand le nom change.
    ════════════════════════════════════════ */
    function genCodeClient(nom) {
      if (!nom) return '—';
      var num = String(Math.floor(Math.random() * 9000) + 1000);
      var slug = nom
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, '')
        .toUpperCase();
      return num + slug;
    }

    /* ════════════════════════════════════════
       INIT VALEURS STATIQUES
    ════════════════════════════════════════ */
    var today    = formatDate(new Date());
    var echeance = getDateEcheance();

    setEl('dv-date',     today);
    setEl('dv-echeance', echeance);
    setEl('dv-numero',   genNumeroDevis(''));

    /* Bloc export PDF — mêmes valeurs statiques */
    setEl('pdf-date',     today);
    setEl('pdf-echeance', echeance);
    setEl('pdf-numero',   genNumeroDevis(''));

    /* ════════════════════════════════════════
       MISE À JOUR LIVE DU DEVIS
    ════════════════════════════════════════ */
    var inputs = {
      prenom:  document.getElementById('pdv-prenom'),
      nom:     document.getElementById('pdv-nom'),
      adresse: document.getElementById('pdv-adresse'),
      cp:      document.getElementById('pdv-cp'),
      ville:   document.getElementById('pdv-ville'),
      tel:     document.getElementById('pdv-tel'),
      email:   document.getElementById('pdv-email')
    };

    var lastNom = '';

    function update() {
      var prenom  = inputs.prenom  ? inputs.prenom.value.trim()  : '';
      var nom     = inputs.nom     ? inputs.nom.value.trim()     : '';
      var adresse = inputs.adresse ? inputs.adresse.value.trim() : '';
      var cp      = inputs.cp      ? inputs.cp.value.trim()      : '';
      var ville   = inputs.ville   ? inputs.ville.value.trim()   : '';
      var tel     = inputs.tel     ? inputs.tel.value.trim()     : '';
      var email   = inputs.email   ? inputs.email.value.trim()   : '';

      /* Destinataire */
      var destNom = (prenom || nom)
        ? 'M. ' + [prenom, nom].filter(Boolean).join(' ')
        : '';
      setEl('dv-dest-nom',     destNom || '—');
      setEl('dv-dest-adresse', adresse || '—');
      setEl('dv-dest-ville',   (cp || ville) ? [cp, ville].filter(Boolean).join(' ') : '—');

      /* Bloc export PDF — destinataire */
      setEl('pdf-dest-nom',     destNom || '—');
      setEl('pdf-dest-adresse', adresse || '—');
      setEl('pdf-dest-ville',   (cp || ville) ? [cp, ville].filter(Boolean).join(' ') : '—');

      /* Infos client */
      setEl('dv-email', email || '—');
      setEl('dv-tel',   tel   || '—');

      /* Bloc export PDF — infos client */
      setEl('pdf-email', email || '—');
      setEl('pdf-tel',   tel   || '—');

      /* Numéro de devis — se met à jour à chaque changement du nom */
      if (nom !== lastNom) {
        lastNom = nom;
        setEl('dv-numero',      genNumeroDevis(nom));
        setEl('dv-code-client', nom ? genCodeClient(nom) : '—');
        /* Bloc export PDF — mêmes valeurs */
        setEl('pdf-numero',      genNumeroDevis(nom));
        setEl('pdf-code-client', nom ? genCodeClient(nom) : '—');
      }
    }

    Object.values(inputs).forEach(function (el) {
      if (el) el.addEventListener('input', update);
    });

    /* ════════════════════════════════════════
       GÉNÉRATION PDF — html2canvas + jsPDF DIRECTS
       (sans html2pdf.js wrapper)

       Pourquoi cette approche :
         html2pdf.js positionne son container interne à
         left: -2×largeur, hors zone rendue par html2canvas
         → canvas vide systématiquement.

       Nouvelle logique :
         1. #devis-pdf-export est un bloc dédié, styles 100 %
            inline, sans aucune dépendance envers la grille
            ou les variables CSS du thème.
         2. Avant capture : display:block, position:fixed,
            top:0, left:0 → l'élément est dans le viewport.
         3. html2canvas le capture à scale:2.
         4. jsPDF encode le canvas en A4 portrait avec
            découpage multi-pages si nécessaire.
         5. Après capture : display:none.
    ════════════════════════════════════════ */
    var H2C_CDN   = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';
    var JSPDF_CDN = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';

    var _pdfLibsReady = false;

    function loadPdfLibs(cb) {
      if (_pdfLibsReady) { cb(); return; }
      if (typeof window.html2canvas === 'function' && window.jspdf) {
        _pdfLibsReady = true;
        cb();
        return;
      }
      var loaded = 0;
      function onLoad() {
        loaded++;
        if (loaded === 2) { _pdfLibsReady = true; cb(); }
      }
      [H2C_CDN, JSPDF_CDN].forEach(function (src) {
        var s   = document.createElement('script');
        s.src   = src;
        s.onload  = onLoad;
        s.onerror = function () { console.error('[devis] Échec chargement : ' + src); };
        document.head.appendChild(s);
      });
    }

    function isMobilePdfEnvironment() {
      return (
        /Android|iPhone|iPod/i.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
      );
    }

    var pdvMobilePdfHelpEl        = document.getElementById('pdv-mobile-pdf-help');
    var pdvMobilePdfHelpBackdrop = document.getElementById('pdv-mobile-pdf-help-backdrop');
    var pdvMobilePdfHelpPanel    = document.getElementById('pdv-mobile-pdf-help-panel');
    var pdvMobilePdfHelpClose    = document.getElementById('pdv-mobile-pdf-help-close');
    var pdvMobilePdfHelpUnderstood = document.getElementById('pdv-mobile-pdf-help-understood');

    function pdvMobilePdfHelpOnKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        closePdvMobilePdfHelp();
      }
    }

    function closePdvMobilePdfHelp() {
      if (!pdvMobilePdfHelpEl) return;
      pdvMobilePdfHelpEl.classList.remove('pdv-mobile-pdf-help--open');
      pdvMobilePdfHelpEl.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', pdvMobilePdfHelpOnKeydown);
    }

    function openPdvMobilePdfHelp() {
      if (!pdvMobilePdfHelpEl || !isMobilePdfEnvironment()) return;
      pdvMobilePdfHelpEl.classList.add('pdv-mobile-pdf-help--open');
      pdvMobilePdfHelpEl.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', pdvMobilePdfHelpOnKeydown);
      if (pdvMobilePdfHelpUnderstood) {
        try { pdvMobilePdfHelpUnderstood.focus(); } catch (eF) {}
      }
    }

    if (pdvMobilePdfHelpBackdrop) {
      pdvMobilePdfHelpBackdrop.addEventListener('click', closePdvMobilePdfHelp);
    }
    if (pdvMobilePdfHelpPanel) {
      pdvMobilePdfHelpPanel.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }
    if (pdvMobilePdfHelpClose) {
      pdvMobilePdfHelpClose.addEventListener('click', closePdvMobilePdfHelp);
    }
    if (pdvMobilePdfHelpUnderstood) {
      pdvMobilePdfHelpUnderstood.addEventListener('click', closePdvMobilePdfHelp);
    }

    window.addEventListener('resize', function () {
      if (
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(min-width: 769px)').matches &&
        pdvMobilePdfHelpEl &&
        pdvMobilePdfHelpEl.classList.contains('pdv-mobile-pdf-help--open')
      ) {
        closePdvMobilePdfHelp();
      }
    });

    var printBtn      = document.getElementById('pdv-print-btn');
    var printBtnLabel = document.getElementById('pdv-print-btn-label');

    if (printBtn) {
      printBtn.addEventListener('click', function () {

        /* Bloc export dédié — styles 100 % inline */
        var exportEl = document.getElementById('devis-pdf-export');
        if (!exportEl) return;

        /*
          Mobile (Safari iOS, Chrome Android, iPadOS) : après html2canvas / jsPDF, la navigation de
          l’opener vers blob: dans un onglet auxiliaire est souvent ignorée ou bloquée sans erreur :
          l’écran « Génération du devis… » reste affiché indéfiniment. Le flux avec onglet de
          prévisualisation est donc réservé au desktop ; sur mobile : pas d’onglet, pdf.save + message bouton.
        */
        var isMobilePdfFlow = isMobilePdfEnvironment();

        /* Onglet réservé au clic (desktop uniquement) — chargement sync dans l’onglet */
        var pdfPreviewTab = null;
        if (!isMobilePdfFlow) {
          try {
            pdfPreviewTab = window.open('about:blank', '_blank');
            if (pdfPreviewTab) {
              try {
                var d0 = pdfPreviewTab.document;
                d0.open();
                d0.write(
                  '<!DOCTYPE html><html><head><meta charset="utf-8">' +
                  '<meta name="viewport" content="width=device-width,initial-scale=1">' +
                  '<title>Devis</title>' +
                  '<style>html,body{height:100%;margin:0}' +
                  'body{font-family:system-ui,-apple-system,sans-serif;display:flex;align-items:center;justify-content:center;background:#f5f5f5;color:#333}' +
                  '.m{text-align:center;padding:1.5rem;max-width:20rem}' +
                  '</style></head><body><div class="m">' +
                  '<p style="font-size:1rem;margin:0">Génération du devis…</p>' +
                  '<p style="font-size:0.875rem;opacity:.8;margin:0.75rem 0 0">Veuillez patienter quelques secondes.</p>' +
                  '</div></body></html>'
                );
                d0.close();
              } catch (eLoadUi) {}
            }
          } catch (ePre) {}
        }

        var numEl        = document.getElementById('dv-numero');
        var numeroActuel = numEl ? numEl.textContent.trim() : 'devis';
        var nomFichier   = 'devis-' + numeroActuel.replace(/[^a-zA-Z0-9\-]/g, '_') + '.pdf';

        printBtn.disabled = true;
        if (printBtnLabel) printBtnLabel.textContent = 'Génération en cours…';

        function restoreBtn() {
          printBtn.disabled = false;
          if (printBtnLabel) printBtnLabel.textContent = 'Télécharger le devis en PDF';
        }

        function restoreBtnMobilePdfDone() {
          printBtn.disabled = false;
          if (printBtnLabel) {
            printBtnLabel.textContent = 'Fichier prêt — consultez Téléchargements ou Fichiers';
          }
          setTimeout(function () {
            if (printBtnLabel) printBtnLabel.textContent = 'Télécharger le devis en PDF';
          }, 6000);
        }

        /* ── Rendre le bloc visible dans le viewport pour la capture ── */
        exportEl.style.display = 'block';

        loadPdfLibs(function () {
          if (typeof window.html2canvas !== 'function' || !window.jspdf) {
            exportEl.style.display = 'none';
            if (pdfPreviewTab && !pdfPreviewTab.closed) {
              try { pdfPreviewTab.close(); } catch (eClose) {}
            }
            console.error('[devis] Bibliothèques PDF non disponibles');
            restoreBtn();
            return;
          }

          /* Deux rAF pour laisser le navigateur rendre le bloc */
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {

              /*
                Mobile : viewport étroit + text-size-adjust implicite peuvent rendre le même HTML
                plus haut que sur desktop ; html2canvas utilise par défaut la largeur « document »,
                ce qui amplifie l’écart. On fige windowWidth/Height sur le bloc 794px pour aligner
                le calcul avec le rendu desktop et éviter une 2e page quasi vide.
              */
              var capW = Math.max(exportEl.scrollWidth, exportEl.offsetWidth, 794);
              var capH = Math.max(exportEl.scrollHeight, exportEl.offsetHeight, 1);

              window.html2canvas(exportEl, {
                scale:           2,
                useCORS:         true,
                allowTaint:      true,
                logging:         false,
                backgroundColor: '#ffffff',
                windowWidth:     capW,
                windowHeight:    capH
              })
              .then(function (canvas) {

                /* Masquer immédiatement le bloc export */
                exportEl.style.display = 'none';

                var jsPDF   = window.jspdf.jsPDF;
                var pdf     = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
                var pdfW    = pdf.internal.pageSize.getWidth();   /* 210 mm */
                var pdfH    = pdf.internal.pageSize.getHeight();  /* 297 mm */
                var margin  = 8; /* mm */
                var usableW = pdfW - 2 * margin;

                /* canvas : html2canvas scale:2 → largeur « CSS px » ≈ canvas.width / scale */
                var scaleUsed = 2;
                var cssPixW   = canvas.width / scaleUsed;
                var mmPerPx   = usableW / cssPixW;
                var imgH_mm   = (canvas.height / scaleUsed) * mmPerPx;
                var usableH   = pdfH - 2 * margin;
                /* Marge mm pour éviter une 2e page quasi vide (flottants / compression JPEG) */
                var singlePageSlackMm = 2;
                var imgData = canvas.toDataURL('image/jpeg', 0.97);

                if (imgH_mm <= usableH + singlePageSlackMm) {
                  /* Une page : si léger dépassement (slack), mise à l’échelle proportionnelle — pas d’écrasement */
                  var dw = usableW;
                  var dh = imgH_mm;
                  if (dh > usableH) {
                    var fit = usableH / dh;
                    dh = usableH;
                    dw = usableW * fit;
                  }
                  var x0 = margin + (usableW - dw) / 2;
                  pdf.addImage(imgData, 'JPEG', x0, margin, dw, dh);
                } else {
                  /* Découpage multi-pages (hauteur slice en px canvas, cohérente avec scaleUsed) */
                  var pageHpx = Math.floor(usableH / mmPerPx) * scaleUsed;
                  var srcY    = 0;
                  var first   = true;

                  while (srcY < canvas.height) {
                    if (!first) pdf.addPage();
                    first = false;

                    var sliceH  = Math.min(pageHpx, canvas.height - srcY);
                    var sc      = document.createElement('canvas');
                    sc.width    = canvas.width;
                    sc.height   = sliceH;
                    var ctx     = sc.getContext('2d');
                    ctx.fillStyle = '#ffffff';
                    ctx.fillRect(0, 0, canvas.width, sliceH);
                    ctx.drawImage(canvas, 0, -srcY);

                    var sliceH_mm = (sliceH / scaleUsed) * mmPerPx;
                    pdf.addImage(sc.toDataURL('image/jpeg', 0.97), 'JPEG', margin, margin, usableW, sliceH_mm);
                    srcY += sliceH;
                  }
                }

                /* Blob typé application/pdf */
                var pdfArrayBuffer = pdf.output('arraybuffer');
                var pdfBlob        = new Blob([pdfArrayBuffer], { type: 'application/pdf' });
                var pdfUrl         = URL.createObjectURL(pdfBlob);

                function navigateTabToPdf(tab, url) {
                  if (!tab || tab.closed) return false;
                  try {
                    tab.location.replace(url);
                    return true;
                  } catch (eR) {
                    try {
                      tab.location.href = url;
                      return true;
                    } catch (eH) {
                      return false;
                    }
                  }
                }

                /* Repli : page avec iframe (même origine que about:blank → le blob reste utilisable) */
                function writeEmbedFallback(tab, url) {
                  if (!tab || tab.closed) return false;
                  try {
                    var safe = String(url).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
                    var d = tab.document;
                    d.open();
                    d.write(
                      '<!DOCTYPE html><html><head><meta charset="utf-8">' +
                      '<meta name="viewport" content="width=device-width,initial-scale=1">' +
                      '<title>Devis</title>' +
                      '<style>html,body{margin:0;padding:0;height:100%;overflow:hidden}' +
                      'iframe{border:0;width:100%;height:100%;min-height:100vh;display:block}</style></head><body>' +
                      '<iframe src="' + safe + '" title="Devis PDF"></iframe></body></html>'
                    );
                    d.close();
                    return true;
                  } catch (eEmb) {
                    return false;
                  }
                }

                /* Repli explicite si aucune navigation / aucun PDF inline possible */
                function writeDownloadInfoFallback(tab) {
                  if (!tab || tab.closed) return false;
                  try {
                    var d = tab.document;
                    d.open();
                    d.write(
                      '<!DOCTYPE html><html><head><meta charset="utf-8">' +
                      '<meta name="viewport" content="width=device-width,initial-scale=1">' +
                      '<title>Devis</title>' +
                      '<style>body{font-family:system-ui,-apple-system,sans-serif;margin:0;padding:1.5rem;background:#f5f5f5;color:#333}' +
                      '.m{max-width:22rem;margin:2rem auto;text-align:center}' +
                      'a{color:#004bcc;font-weight:600}</style></head><body><div class="m">' +
                      '<p style="margin:0 0 0.75rem;font-size:1rem">Le devis a été enregistré sur votre appareil.</p>' +
                      '<p style="margin:0;font-size:0.875rem;opacity:.85">Ouvrez vos téléchargements ou les fichiers récents pour le consulter. ' +
                      'Si rien n’apparaît, revenez sur la page et utilisez à nouveau le bouton d’export.</p>' +
                      '</div></body></html>'
                    );
                    d.close();
                    return true;
                  } catch (eMsg) {
                    return false;
                  }
                }

                if (isMobilePdfFlow) {
                  pdf.save(nomFichier);
                  setTimeout(function () {
                    try { URL.revokeObjectURL(pdfUrl); } catch (eRev) {}
                  }, 120000);
                  restoreBtnMobilePdfDone();
                  setTimeout(function () {
                    openPdvMobilePdfHelp();
                  }, 0);
                } else {
                  var openedInTab = pdfPreviewTab && navigateTabToPdf(pdfPreviewTab, pdfUrl);
                  if (!openedInTab && pdfPreviewTab && !pdfPreviewTab.closed) {
                    openedInTab = writeEmbedFallback(pdfPreviewTab, pdfUrl);
                  }
                  if (pdfPreviewTab && !pdfPreviewTab.closed && !openedInTab) {
                    writeDownloadInfoFallback(pdfPreviewTab);
                  }
                  pdf.save(nomFichier);
                  setTimeout(function () {
                    try { URL.revokeObjectURL(pdfUrl); } catch (eRev) {}
                  }, 120000);
                  restoreBtn();
                }
              })
              .catch(function (err) {
                exportEl.style.display = 'none';
                if (pdfPreviewTab && !pdfPreviewTab.closed) {
                  try { pdfPreviewTab.close(); } catch (eClose2) {}
                }
                console.error('[devis] html2canvas error :', err);
                restoreBtn();
              });

            });
          });
        });
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-fuite"] && !Shopify.designMode) return;
  try {
    
(function () {
  var pipe = document.querySelector('.fuite-pipe');
  if (!pipe) return;

  var fill = pipe.querySelector('.fuite-pipe__fill');

  var rafPending = false;
  function onScroll() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(function () {
      rafPending = false;
      var docH       = document.documentElement.scrollHeight;
      var vh         = window.innerHeight;
      var scrollable = docH - vh;
      var ratio      = scrollable > 0
        ? Math.min(1, Math.max(0, window.scrollY / scrollable))
        : 0;

      fill.style.transform = 'scaleY(' + ratio + ')';
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    onScroll();
  }, { passive: true });
  onScroll();
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-photos-installation"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (/\benvoi=ok\b/.test(window.location.search)) {
      var ok = document.getElementById('photos-envoi-ok');
      var form = document.querySelector('.photos-install__form');
      if (ok) ok.hidden = false;
      if (form) form.hidden = true;
    }
    var input = document.getElementById('photos-install-files');
    var out = document.querySelector('[data-photos-file-names]');
    if (!input || !out) return;
    input.addEventListener('change', function () {
      var files = input.files;
      if (!files || !files.length) {
        out.textContent = '';
        return;
      }
      var names = [];
      for (var i = 0; i < files.length; i++) {
        names.push(files[i].name);
      }
      out.textContent = names.join(', ');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    /* ── Galerie : changement d'image ── */
    var thumbs      = document.querySelectorAll('.prod-gallery__thumb');
    var featured    = document.getElementById('prod-gallery__featured');
    var featuredBtn = document.getElementById('prod-gallery__featured-btn');

    if (featured && thumbs.length) {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          featured.src = this.dataset.src;
          featured.alt = this.dataset.alt || '';
          if (featuredBtn) {
            if (this.dataset.zoomSrc) {
              featuredBtn.setAttribute('data-zoom-src', this.dataset.zoomSrc);
            }
            featuredBtn.setAttribute('data-zoom-alt', this.dataset.alt || '');
          }
          thumbs.forEach(function (t) { t.classList.remove('prod-gallery__thumb--active'); });
          this.classList.add('prod-gallery__thumb--active');
        });
      });
    }

    /* ── Lightbox : galerie navigable ── */
    var lightbox = document.getElementById('prod-lightbox');
    if (lightbox && featuredBtn && featured) {
      var lightboxImg    = document.getElementById('prod-lightbox__img');
      var lightboxStage  = document.getElementById('prod-lightbox-stage');
      var closeTargets   = lightbox.querySelectorAll('[data-lightbox-close]');
      var closeBtn       = lightbox.querySelector('.prod-lightbox__close');
      var prevBtns       = lightbox.querySelectorAll('[data-lightbox-prev]');
      var nextBtns       = lightbox.querySelectorAll('[data-lightbox-next]');
      var counterEl      = document.getElementById('prod-lightbox-counter');
      var galleryJsonEl  = document.getElementById('prod-gallery-images-json');
      var lastFocused    = null;
      var slides         = [];
      var currentIndex   = 0;
      var touchStartX    = 0;
      var touchStartY    = 0;

      if (galleryJsonEl) {
        try {
          slides = JSON.parse(galleryJsonEl.textContent || '[]');
        } catch (e) {
          slides = [];
        }
      }

      if (!slides.length) {
        slides = [{
          zoom: featuredBtn.getAttribute('data-zoom-src') || featured.src,
          src: featured.src,
          alt: featuredBtn.getAttribute('data-zoom-alt') || featured.alt || ''
        }];
      }

      function getActiveIndex() {
        var activeThumb = document.querySelector('.prod-gallery__thumb--active');
        if (activeThumb && thumbs.length) {
          var idx = Array.prototype.indexOf.call(thumbs, activeThumb);
          if (idx >= 0) return idx;
        }
        return 0;
      }

      function updateNavVisibility() {
        var multi = slides.length > 1;
        prevBtns.forEach(function (btn) {
          if (multi) btn.removeAttribute('hidden');
          else btn.setAttribute('hidden', '');
        });
        nextBtns.forEach(function (btn) {
          if (multi) btn.removeAttribute('hidden');
          else btn.setAttribute('hidden', '');
        });
        if (counterEl) {
          if (multi) counterEl.removeAttribute('hidden');
          else counterEl.setAttribute('hidden', '');
        }
      }

      function syncGalleryToIndex(index) {
        var slide = slides[index];
        if (!slide) return;
        if (featured) {
          featured.src = slide.src || slide.zoom;
          featured.alt = slide.alt || '';
        }
        if (featuredBtn) {
          featuredBtn.setAttribute('data-zoom-src', slide.zoom || slide.src || '');
          featuredBtn.setAttribute('data-zoom-alt', slide.alt || '');
        }
        if (thumbs.length) {
          thumbs.forEach(function (t, i) {
            t.classList.toggle('prod-gallery__thumb--active', i === index);
          });
        }
      }

      function showLightboxSlide(index) {
        if (!slides.length || !lightboxImg) return;
        currentIndex = (index + slides.length) % slides.length;
        var slide = slides[currentIndex];
        lightboxImg.classList.add('is-changing');
        lightboxImg.src = slide.zoom || slide.src;
        lightboxImg.alt = slide.alt || '';
        if (counterEl) {
          counterEl.textContent = (currentIndex + 1) + ' / ' + slides.length;
        }
        lightbox.setAttribute(
          'aria-label',
          'Image agrandie ' + (currentIndex + 1) + ' sur ' + slides.length
        );
        syncGalleryToIndex(currentIndex);
        lightboxImg.onload = function () {
          lightboxImg.classList.remove('is-changing');
        };
        if (lightboxImg.complete) {
          lightboxImg.classList.remove('is-changing');
        }
      }

      function openLightbox() {
        currentIndex = getActiveIndex();
        updateNavVisibility();
        showLightboxSlide(currentIndex);
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.classList.add('prod-lightbox-open');
        lastFocused = document.activeElement;
        if (closeBtn) {
          try { closeBtn.focus({ preventScroll: true }); } catch (e) { closeBtn.focus(); }
        }
      }

      function closeLightbox() {
        if (lightbox.getAttribute('aria-hidden') === 'true') return;
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('prod-lightbox-open');
        lightboxImg.removeAttribute('src');
        lightboxImg.alt = '';
        lightboxImg.classList.remove('is-changing');
        if (lastFocused && typeof lastFocused.focus === 'function') {
          try { lastFocused.focus({ preventScroll: true }); } catch (e) { lastFocused.focus(); }
        }
      }

      function goNext(e) {
        if (e) e.preventDefault();
        if (slides.length <= 1) return;
        showLightboxSlide(currentIndex + 1);
      }

      function goPrev(e) {
        if (e) e.preventDefault();
        if (slides.length <= 1) return;
        showLightboxSlide(currentIndex - 1);
      }

      featuredBtn.addEventListener('click', openLightbox);

      closeTargets.forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          closeLightbox();
        });
      });

      prevBtns.forEach(function (btn) {
        btn.addEventListener('click', goPrev);
      });

      nextBtns.forEach(function (btn) {
        btn.addEventListener('click', goNext);
      });

      if (lightboxStage) {
        lightboxStage.addEventListener('touchstart', function (e) {
          if (lightbox.getAttribute('aria-hidden') !== 'false' || slides.length <= 1) return;
          var touch = e.changedTouches[0];
          touchStartX = touch.screenX;
          touchStartY = touch.screenY;
        }, { passive: true });

        lightboxStage.addEventListener('touchend', function (e) {
          if (lightbox.getAttribute('aria-hidden') !== 'false' || slides.length <= 1) return;
          var touch = e.changedTouches[0];
          var deltaX = touch.screenX - touchStartX;
          var deltaY = touch.screenY - touchStartY;
          if (Math.abs(deltaX) < 48 || Math.abs(deltaX) < Math.abs(deltaY)) return;
          if (deltaX < 0) goNext();
          else goPrev();
        }, { passive: true });
      }

      document.addEventListener('keydown', function (e) {
        if (lightbox.getAttribute('aria-hidden') !== 'false') return;
        if (e.key === 'Escape' || e.key === 'Esc') {
          closeLightbox();
          return;
        }
        if (slides.length <= 1) return;
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          goNext();
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          goPrev();
        }
      });
    }

    function formatFrenchMoneyCents(cents) {
      var n = Number(cents);
      if (isNaN(n)) n = 0;
      return (n / 100).toFixed(2).replace('.', ',') + ' \u20ac';
    }

    function normalizeIndicatifDisplay(raw, priceCents) {
      var fallbackPrice = Number(priceCents);
      if (raw === null || raw === undefined) return fallbackPrice <= 0 ? 'Sur devis' : formatFrenchMoneyCents(priceCents);
      if (typeof raw === 'number' && !isNaN(raw)) {
        return Number(raw) <= 0 ? 'Sur devis' : formatFrenchMoneyCents(Math.round(Number(raw)));
      }
      var s = String(raw).replace(/\u00a0/g, ' ').trim();
      if (!s) return fallbackPrice <= 0 ? 'Sur devis' : formatFrenchMoneyCents(priceCents);
      s = s.replace(/[€\u20ac]/g, '').replace(/\s+/g, ' ').trim();
      if (!s) return fallbackPrice <= 0 ? 'Sur devis' : formatFrenchMoneyCents(priceCents);
      if (/^0([,.]0+)?$/.test(s)) return 'Sur devis';
      return s + ' \u20ac';
    }

    /* ── Variants : mise à jour du prix ── */
    var variantSelect    = document.getElementById('prod-variant-select');
    var variantIdInput   = document.getElementById('prod-variant-id');
    var equipementJsonEl = document.getElementById('prod-equipement-variants-json');
    var indicatifEl      = document.getElementById('prod-indicatif-amount');
    var priceDisplay     = document.getElementById('prod-price-display');

    if (variantSelect && equipementJsonEl && indicatifEl) {
      var eqVariants = [];
      try {
        eqVariants = JSON.parse(equipementJsonEl.textContent || '[]');
      } catch (e) {
        eqVariants = [];
      }
      var addToCartBtn = document.querySelector('.prod-buy-btn--cart');
      var indicatifFromProductMetafield = equipementJsonEl.getAttribute('data-prix-indicatif-produit') === 'true';

      function applyEqVariantById(vid) {
        var selected = eqVariants.find(function (v) { return String(v.id) === String(vid); });
        if (!selected) return;
        if (indicatifFromProductMetafield) {
          var pi = selected.prix_indicatif;
          if (pi !== null && pi !== undefined && String(pi).trim() !== '') {
            indicatifEl.textContent = normalizeIndicatifDisplay(pi, selected.price);
          } else {
            indicatifEl.textContent = '';
          }
        } else {
          indicatifEl.textContent = normalizeIndicatifDisplay(selected.prix_indicatif, selected.price);
        }
        if (variantIdInput) variantIdInput.value = selected.id;
        var ok = !!selected.available;
        if (addToCartBtn) {
          addToCartBtn.disabled = !ok;
          addToCartBtn.setAttribute('aria-disabled', ok ? 'false' : 'true');
          addToCartBtn.textContent = ok ? 'Ajouter au panier' : 'Indisponible';
        }
      }

      variantSelect.addEventListener('change', function () {
        applyEqVariantById(variantSelect.value);
      });
      applyEqVariantById(variantSelect.value);
    } else if (variantSelect && priceDisplay) {
      var variants = JSON.parse(variantSelect.dataset.variants || '[]');
      var priceCompare = document.getElementById('prod-price-compare');
      variantSelect.addEventListener('change', function () {
        var selected = variants.find(function (v) { return String(v.id) === variantSelect.value; });
        if (!selected) return;
        priceDisplay.textContent = Number(selected.price) <= 0 ? 'Sur devis' : formatFrenchMoneyCents(selected.price);
        if (priceCompare) {
          var p = Number(selected.price);
          var cap = selected.compare_at_price;
          var c = cap != null && cap !== '' ? Number(cap) : 0;
          if (c > p) {
            priceCompare.textContent = formatFrenchMoneyCents(c);
            priceCompare.removeAttribute('hidden');
          } else {
            priceCompare.textContent = '';
            priceCompare.setAttribute('hidden', '');
          }
        }
        if (variantIdInput) variantIdInput.value = selected.id;
      });
    }

    /* ── Photo : compression + base64 ── */
    var photoInput   = document.getElementById('prod-photo-input');
    var photoPreview = document.getElementById('prod-photo-preview');
    var photoData    = document.getElementById('prod-photo-data');
    var photoWarning = document.getElementById('prod-photo-warning');
    var photoArea    = document.getElementById('prod-photo-area');
    var photoLabel   = document.getElementById('prod-photo-area-label');

    if (!photoInput) return;

    photoInput.addEventListener('change', function () {
      var file = this.files[0];
      if (!file) return;

      var reader = new FileReader();
      reader.onload = function (e) {
        var img = new Image();
        img.onload = function () {
          var canvas = document.createElement('canvas');
          var maxW = 900;
          var w = img.width;
          var h = img.height;
          if (w > maxW) { h = Math.round(h * maxW / w); w = maxW; }
          canvas.width  = w;
          canvas.height = h;
          canvas.getContext('2d').drawImage(img, 0, 0, w, h);

          /* JPEG 72% — résultat ~100-250 Ko pour photo de chantier standard */
          var dataUrl   = canvas.toDataURL('image/jpeg', 0.72);
          var byteSize  = Math.round(dataUrl.length * 0.75);

          if (byteSize > 210000) {
            /* Trop lourd pour le formulaire Shopify (~256 Ko limite) */
            photoWarning.hidden = false;
            photoData.value = '[Photo trop volumineuse \u2013 \u00e0 envoyer s\u00e9par\u00e9ment]';
          } else {
            photoWarning.hidden = true;
            photoData.value = dataUrl;
          }

          photoPreview.src    = dataUrl;
          photoPreview.hidden = false;
          if (photoLabel) photoLabel.textContent = file.name;
          if (photoArea)  photoArea.classList.add('has-photo');
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
